import ScrollToTop from './components/ScrollToTop';
import { Suspense, lazy } from 'react';
import GlobalContactModal from './components/public/GlobalContactModal';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminGuard from './guards/AdminGuard';

// -- IMPORTS STATIQUES PUBLICS & ADMIN --
import Home from './pages/public/Home';
import Janus from './pages/public/Janus';
import AssetManagement from './pages/public/AssetManagement';
import DigitalAssets from './pages/public/DigitalAssets';
import Sovereignty from './pages/public/Sovereignty';
import MentionsLegales from './pages/public/legal/MentionsLegales';
import Confidentialite from './pages/public/legal/Confidentialite';
import AvertissementRisques from './pages/public/legal/AvertissementRisques';
import Book from './pages/public/Book';
import AdminLogin from './pages/admin/Login';
import AdminLayout from './layouts/AdminLayout';
import PublicLayout from './layouts/PublicLayout';

// -- IMPORTS DYNAMIQUES ADMIN --
const DashboardPage = lazy(() => import('./pages/admin/Dashboard'));
const TelegramPage = lazy(() => import('./pages/admin/Telegram'));
const ArticlesPage = lazy(() => import('./pages/admin/Articles'));
const RealEstatePage = lazy(() => import('./pages/admin/RealEstate'));
const MediaPage = lazy(() => import('./pages/admin/Media'));
const Contacts = lazy(() => import('./pages/admin/Contacts'));
const SettingsPage = lazy(() => import('./pages/admin/Settings'));

// -- IMPORTS DYNAMIQUES PUBLICS --
const AssetsPublic = lazy(() => import('./pages/public/Listings'));
const PropertyPublic = lazy(() => import('./pages/public/Property'));
const InsightsPublic = lazy(() => import('./pages/public/Insights'));
const ArticlePublic = lazy(() => import('./pages/public/Article'));
const UnsubscribePage = lazy(() => import('./pages/public/Unsubscribe'));
const ArchitectPublic = lazy(() => import("./pages/public/Architect"));

// -- IMPORTS DYNAMIQUES PORTAIL CLIENT (NOUVEAU) --
const ClientLogin = lazy(() => import('./pages/portal/ClientLogin'));
const ClientLayout = lazy(() => import('./layouts/ClientLayout'));
const ClientDashboard = lazy(() => import('./pages/portal/Dashboard'));
const ClientFavorites = lazy(() => import('./pages/portal/Favorites'));
const ClientProfile = lazy(() => import('./pages/portal/Profile'));

function App() {
  return (
    <Router>
      <Suspense fallback={<div style={{ background: '#faf8f3', minHeight: '100vh' }} />}>
        <ScrollToTop />
        <GlobalContactModal />
        <Routes>
          {/* 1. LA VITRINE PUBLIQUE */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/janus" element={<Janus />} />
            <Route path="/asset-management" element={<AssetManagement />} />
            <Route path="/digital-assets" element={<DigitalAssets />} />
            <Route path="/sovereignty" element={<Sovereignty />} />
            <Route path="/portfolio" element={<AssetsPublic />} />
            <Route path="/portfolio/:slug" element={<PropertyPublic />} />
            <Route path="/portfolio/:type/:slug" element={<PropertyPublic />} />
            <Route path="/insights" element={<InsightsPublic />} />
            <Route path="/insights/:slug" element={<ArticlePublic />} />
            <Route path="/unsubscribe" element={<UnsubscribePage />} />
            <Route path="/architect" element={<ArchitectPublic />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/avertissement-risques" element={<AvertissementRisques />} />
            <Route path="/book" element={<Book />} />
          </Route>

          {/* 2. L'ARRIÈRE BOUTIQUE (ADMIN / AGENTS) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminGuard />}>
            <Route element={<AdminLayout />}>
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="telegram" element={<TelegramPage />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="articles" element={<ArticlesPage />} />
              <Route path="real-estate" element={<RealEstatePage />} />
              <Route path="media" element={<MediaPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
          </Route>

          {/* 3. LE PORTAIL PRIVÉ CLIENTS */}
          <Route path="/portal/login" element={<ClientLogin />} />
          <Route path="/portal" element={<ClientLayout />}>
            <Route index element={<Navigate to="/portal/dashboard" replace />} />
            <Route path="dashboard" element={<ClientDashboard />} />
            <Route path="favorites" element={<ClientFavorites />} />
            <Route path="profile" element={<ClientProfile />} />
          </Route>

          {/* REDIRECTION PAR DÉFAUT */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
